export const ApiUrl = process.env.REACT_APP_BASE_URL;
export const StatusCode = {
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
};

export const fullAccessSuperAdminRoles = ["rm_superadmin", "admin", "approver"];

export const fullAccessDistributorRoles = ["distributor_superadmin"];

export const assignRoles = [
  {
    label: "Super Admin",
    value: "rm_superadmin",
  },
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Approver",
    value: "approver",
  },
  {
    label: "User",
    value: "user",
  },
  {
    label: "Sales Executive",
    value: "salesrepresentative",
  },
];

export const assignDistributorAdminRoles = [
  {
    label: "Super Admin",
    value: "distributor_superadmin",
  },
];

export const affiliateOptions = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const assignDistributorRoles = [
  {
    label: "Super Admin",
    value: "distributor_superadmin",
  },

  {
    label: "Sales Executive",
    value: "distributor_salesrepresentative",
  },
];

export const userPermissions = [
  {
    column: "col-4",
    type: "switch",
    id: "Manage Products",
    label: "Manage Products",
  },
  {
    column: "col-4",
    type: "switch",
    id: "Kit Management",
    label: "Manage Batch Creation",
  },
  {
    column: "col-4",
    type: "switch",
    id: "Manage Resource Center",
    label: "Manage Resource Center",
  },
  {
    column: "col-4",
    type: "switch",
    id: "Manage Distributors",
    label: "Manage Distributors",
  },
  {
    column: "col-4",
    type: "switch",
    id: "Manage Company Users",
    label: "Manage Team Members",
  },
  {
    column: "col-4",
    type: "switch",
    id: "Manage Business Profile",
    label: "Manage Business Profile",
  },
  // {
  //   column: "col-4",
  //   type: "switch",
  //   id: "Receive Update Notifications",
  //   label: "Receive Update Notifications",
  // },
];

export const userPermissionsDistributor = [
  {
    column: "col-4",
    type: "switch",
    id: "Manage Company Users",
    label: "Manage Team Members",
  },
  {
    column: "col-4",
    type: "switch",
    id: "Manage Business Profile",
    label: "Manage Business Profile",
  },
  {
    column: "col-4",
    type: "switch",
    id: "Manage Clients",
    label: "Manage Clients",
  },
  // {
  //   column: "col-4",
  //   type: "switch",
  //   id: "Receive Update Notifications",
  //   label: "Receive Notifications",
  // },
];

export const ApiEndPoint = {
  LOGIN: "/admin/login",
  DISTRIBUTORREGISTER: "/admin/create_distributor",
  DISTRIBUTORQR: "/admin/download_qr_code",
  AUTHUSER: "/user/my_account",
  USERMANAGEMENT: "/admin/get_user",
  PRODUCTMANAGEMENT: "/admin/fetch_products",
  FETCH_BRANDS: "/admin/fetch_brands",
  KITMANAGEMENT: "/admin/fetch_batch_kit_creation",
  ADMINFETCHLOCATION: "/admin/fetch_location",
  CREATENEWUSER: "/admin/register_user",
  REFRESHTOKEN: "/user/refresh_token",
  DISTRIBUTORMANAGEMENT: "/admin/fetch_distributor",
  BUSINESSPROFILE: "/admin/fetch_location",
  GET_NOTIFICATION: "/notification/all",
  CREATE_NOTIFICATION: "/notification/create",
  NOTIFICATION: "/notification/",
  NOTIFICATION_DELETE: "/notification/delete",
  ARTICLEREGISTRATION: "/admin/create_article",
  SUPERADMINAPPROVERDATA: "/admin/get_approver",
  BUSINESSPROFILEFORM: "/admin/fetch_business_details",
  UPDATEBUSINESSPROFILE: "/admin/edit_business_details",
  ADDLOCATION: "/admin/add_location",
  DASHBOARDLISTING: "/admin/new_web_dashboard_details",
  REGISTEREDKIT: "/admin/get_registered_kit_counts_by_range",
  FETCH_HEATMAP: "/admin/fetch_heatmap_data",
  REPORTSLISTING: "/admin/fetch_report_group",
  CREATEGROUPREPORT: "/admin/create_report_group",
  CREATEREPORT: "/report/create_report",
  REPORTSDATA: "/admin/get_reportData_list",
  CREATEBATCHKIT: "/admin/create_batch_kit",
  START_BATCH_KIT: "/admin/start_batch_kit_creation/",
  CREATEMPTYKIT: "/admin/register_empty_kit",
  USERMANAGEMENTDATABYID: "/admin/get_user_by_id",
  UPDATEUSERMANAGEMENTDATA: "/admin/update_user_profile",
  DELETEUSERMANAGEMENTDATA: "/admin/delete_user",
  REPORTS: "/admin/fetch_reports",
  DISTRIBUTORCLIENTMANAGEMENT: "/admin/get_clients",
  DELETEREPORTGROUPDATA: "/admin/delete_report_group_by_id",
  DELETEREPORTLISTDATA: "/admin/delete_reports",
  UPDATE_GROUP_DETAILS: "/admin/update_report_group_by_id",
  GROUPDATABYID: "/admin/get_report_group_by_id",
  REPORTDATABYID: "/admin/get_report_by_id",
  UPDATE_REPORT_DETAILS: "/admin/update_report_by_id",
  INVITE: "/admin/send_invitation_mail",
  // endpoint for import files
  IMPORTPRODUCT: "/product/import_kits_and_products",
  IMPORTUSER: "/admin/import_users",
  IMPORTDISTRIBUTOR: "/admin/import_users",
  GET_CATEGORY_CLASSFICATION: "/admin/incident_categories",
  QUICKINCIDENTREPORT: "/admin/web_quick_incident",
  QUICKDETAILEDINCIDENTREPORT: "/admin/web_detailed_incident",
  BATCHKITS: "/admin/fetch_kit_products",
  UPDATEARTICAL: "/admin/update_article_by_id",
  DELETEKITMANAGEMENTDATA: "/admin/delete_kits",
  DELETEDISTRIBUTORMANAGEMENTDATA: "/admin/delete_distributor",
  GET_DISTRIBUTER_DETAILS: "/admin/get_distributor_by_id",
  UPDATE_DISTRIBUTER_DETAILS: "/admin/update_distributor",
  DELETEPRODUCTMANAGEMENTDATA: "",
  EXPORTFILES: "/admin/export_products",
  EXPORTUSERS: "/admin/export_users",
  EXPORTDIST: "/admin/export_distributors",
  EXPORTKITS: "/admin/export_registered_kits", // Distributor dashboard
  DISTRUBUTORDASHBOARD: "/admin/new_web_dashboard_details",
  DELETELOCATIONDATA: "/admin/delete_location",
  UPDATELOCATIONDATA: "/admin/update_location",
  UPDATEDISTRIBUTORMANAGEMENTDATA: "",
  GET_USERS: "/admin/get_users_for_web",
  FETCH_PDF_DATA: "admin/fetch_pdf_data",
  FORGET_PASSWORD: "forget_password",
  RESET_PASSWORD: "reset_password",
  DELETE_BATCH: "/admin/delete_batch_kit_creation",
  INJURY_TYPE_DATA: "/admin/fetch_injury_type_data",
};
